import React from 'react';
import useFetchData from '../../../../../Hooks/useFetchData';
import { GetAgentPerformanceOverviewSummary } from '../../../../../Services';
import {
  formatCamelCaseToCapitalized,
  formatNumberWithCommas,
} from '../../utilities/helpers';
import { Spinner } from '../../../../../Components';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    marginBottom: '16px',
    position: 'relative',
    padding: '16px',
  },
  card: {
    padding: '16px',
    borderRadius: '16px',
    border: '1px solid #e5e7eb',
    flex: '1 1 calc(33.333% - 16px)',
    minWidth: '200px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
});
const AgentPerformanceKPIsCards = () => {
  const { data, loading: kpiLoading } = useFetchData(
    GetAgentPerformanceOverviewSummary
  );
  const classes = useStyles();
  return (
    <div className={classes.cardsContainer}>
      {kpiLoading ? (
        <Spinner isAbsolute isActive={kpiLoading} isSmall />
      ) : (
        Object.entries(data).map(([key, value]) => (
          <div key={key} className={classes.card}>
            <h5>{formatCamelCaseToCapitalized(key)}</h5>
            <h3>
              <strong>{formatNumberWithCommas(value)}</strong>
            </h3>
          </div>
        ))
      )}
    </div>
  );
};
export default AgentPerformanceKPIsCards;
